<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group row mb-4">
              <h4 class="col-lg-12 mb-3 font-size-16">{{ $t('tasks.talent_accepted') }}</h4>
              <!--<div class="col-lg-12 text-muted">{{ $t('tasks.talent_accepted_description') }}</div>-->
              <div class="col-lg-12">
                <b-table
                  ref="selectableTable"
                  selectable
                  hover
                  :select-mode="selectMode" 
                  :items="taskApplicants"
                  :fields="tableFields"
                  @row-selected="assignPerson"
                  responsive="sm"
                >
                <template #cell(name)="applicant">
                  {{ applicant.item.lastName }}, {{ applicant.item.firstName }}
                </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h5 class="mb-3 font-size-16">{{ $t('tasks.talent_others') }}</h5>
            <b-table
                :items="taskOtherTalents"
                :fields="tableStateFields"
                responsive="sm"
            >
              <template #cell(name)="talent">
                {{ talent.item.lastName }}, {{ talent.item.firstName }}
              </template>
              <template #cell(state)="talent">
                {{ getBeautifiedTaskState(talent.item.state) }}
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import i18n from '@/i18n';
import { taskService } from '@/helpers/services/tasks/taskService';
export default {
  name: "TaskReadyToAssign",
  props: {
    taskId: {
      type: String,
      required: true,
    },
    taskTitle: {
      required: true,
    },
  },
  data() {
    return {
      selectMode: "single",
      tableFields: [
        { key: "name", label: i18n.t("talents.form.name") },
        { key: "department", label: i18n.t("talents.form.department") },
      ],
      tableStateFields: [
        { key: "name", label: i18n.t("talents.form.name") },
        { key: "department", label: i18n.t("talents.form.department") },
        { key: "state", label: i18n.t("tasks.talents-table.form.state") },
      ],
      taskApplicants: [],
      taskOtherTalents: []
    }
  },
  methods: {
    assignPerson(selectedApplicant) {
      Swal.fire({
        title: i18n.t("tasks.status.assign-task-modal.title"),
        html: i18n.t(
          "tasks.status.assign-task-modal.text",
          {taskTitle: this.taskTitle, firstName: selectedApplicant[0].firstName, lastName: selectedApplicant[0].lastName}
        ),
        icon: 'success',
        confirmButtonText: `<i class="bx bx-chat" aria-hidden="true"></i> ${i18n.t("tasks.status.assign-task-modal.confirm-button-text")}`,
        cancelButtonText: i18n.t("no"),
        showCancelButton: true,
        confirmButtonColor: '#556ee6',
        cancelButtonColor: "rgba(221, 51, 51, 0.7)",
      }).then((result) => {
        if (result.value) {
          const assigneeIds = selectedApplicant.map(assignee => assignee.id);
          this.$emit("assignTask", {assigneeIds});
        }
      })
    },
    getBeautifiedTaskState(state) {
      return i18n.t(`tasks.${state.toLowerCase()}`).toString();
    }
  },
  created() {
    taskService.fetchTaskTalentsOrdered(this.taskId)
      .then(ta => {
        ta.forEach(talent => {
          switch (talent.state) {
            case 'APPLIED':
              this.taskApplicants.push(talent)
                  break
            default:
              this.taskOtherTalents.push(talent)
          }
        })
      });
    taskService.fetchTaskApplicants(this.taskId)
      .then(ta => this.taskApplicants = ta);
  },
}
</script>